import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { ShowcaseCreate } from '../../services';

export const fetchShowcaseCreate = createAsyncThunk(
    'showcaseCreate/fetchShowcaseCreate',
    async ({ file, slug, title, description, content, sort, productId, isAbout, specialField1, isNews }) => {
        const response = await ShowcaseCreate(file, slug, title, description, content, sort, productId, isAbout, specialField1, isNews)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const showcaseCreateSlice = createSlice({
    name: 'showcaseCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowcaseCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchShowcaseCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchShowcaseCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default showcaseCreateSlice.reducer;
